import BaseAPI, { MAX_LIST_LIMIT } from "./BaseAPI";
import { vehicleRoute } from "../routes";

export default class VehicleAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, vehicleRoute, "vehicle");
    }

    async List(params = {}) {
        return super.List({ limit: MAX_LIST_LIMIT, ...params });
    }

    getEmptyVehicle() {
        return {
            registration: "",
            make: "",
            model: ""
        };
    }
}
